<template>
  <div class="SNews">
    <div class="img">
      <my_image :src="news.img" :width="imgWidth"></my_image>
    </div>
    <div class="news">
      <div class="title fs18">{{news.title}}</div>
      <div class="time fs12">发布时间：{{news.date}}</div>
      <div class="preview fs12">{{news.preview}}</div>
      <div class="readfull">
        <my_button :value="button" :inputStyle="buttonStyle" @click.native="nav"></my_button>
      </div>
    </div>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue'
 import MyButton from '@/components/Button.vue';
export default {
  name: 'SNews',
   props: ['news'],
   components:{
     my_image: MyImage,
     my_button: MyButton
   },
   methods: {
     nav() {
       window.open(this.news.url, '_blank');
     }
   },
   computed: {
     imgWidth() {
       return '12.3vw';
     },
     button() {
       return '阅读全文'
     },
     buttonStyle() {
       return {
         width: '6em',
         height: '1.67vw',
         border: '1px solid #2f4fff',
         'background-color': 'white',
         color: '#2f4fff',
         'font-size': '0.73vw'
       }
     }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .SNews{
   width: 57.7vw;
   height: 11.35vw;
   border-bottom: 1px solid #E3E3E3;
   display: flex;
   align-items:center;
   justify-content: space-between;
 }
 .news{
   width: 42.45vw;
   height: 8.4375vw;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
 }
 .title{
   color: #424242;
 }
 .time{
   margin-top: 0.6vw;
   justify-self: flex-start;
   color: #9b9a9f;
 }
 .preview{
   flex-grow: 1;
   color: #9B9A9F;
   display: flex;
   align-items:center;
 }
</style>
